module.exports = __webpack_public_path__ + "static/img/saoma.3b486ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/saoma.png
// module id = OMxw
// module chunks = 1